import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { CustomNavLink } from "src/components/Common/CustomLink";
import { useTranslation } from "react-i18next";
import APP_ROUTES from "src/routes/routes";
import logo from "src/assets/images/logo.png";
import { useRecoilState, useSetRecoilState, useRecoilValue } from "recoil";
import { sidebarState } from "src/recoil/atoms/sidebar";
import DashboardIcon from "src/assets/images/dashboard.png";
import InstanceIcon from "src/assets/images/instance.png";
import PackageIcon from "src/assets/images/package.png";
import SequenceIcon from "src/assets/images/sequence.png";
import { resetFormPromptState, projectResourcesState } from "src/recoil/atoms/global";
import { REACT_APP_PORTAL_URL } from "src/constant/environment";
import { RESOURCE_TYPE } from "src/constant/common";

const SidebarHeader = ({ children, needReset, ...rest }) => {
  const { t } = useTranslation("topbar");

  return (
    <div className="sidebar-header m-b-3 m-t-3">
      <div style={{ display: "flex", alignItems: "center" }}>
        <a href={REACT_APP_PORTAL_URL} target="_blank" rel="noreferrer">
          <img src={logo} alt="" height="48" />
        </a>
        <div className="fw-bold m-l-10" style={{ textWrap: "nowrap" }}>
          {t("title")}
        </div>
      </div>
    </div>
  );
};

const SidebarMenu = () => {
  const { t } = useTranslation("sidebar");
  const [sidebar, setSidebar] = useRecoilState(sidebarState);
  const projectResources = useRecoilValue(projectResourcesState);
  const [broken, setBroken] = useState(false);
  const location = useLocation();
  const isMenuItemActive = (to) => location.pathname === to;
  const setResetFormState = useSetRecoilState(resetFormPromptState);

  useEffect(() => {
    setSidebar({ ...sidebar, broken: broken });
  }, [broken]);

  const isShowMenu = (resourceType) => {
    return projectResources.includes(resourceType);
  };

  return (
    <React.Fragment>
      <Sidebar
        collapsed={sidebar.collapsed}
        toggled={sidebar.toggled}
        onBackdropClick={() => setSidebar({ ...sidebar, toggled: false })}
        backgroundColor="white"
        onBreakPoint={setBroken}
        breakPoint="lg"
      >
        <SidebarHeader needReset={isMenuItemActive(APP_ROUTES.HOME)} />
        <Menu renderExpandIcon={({ open }) => <i className={`bi ${open ? "bi-chevron-down" : "bi-chevron-right"} fs-12`}></i>}>
          {
            isShowMenu(RESOURCE_TYPE.PROJECT_INSTANCE) && (
            <MenuItem
              icon={<img src={DashboardIcon} className="width-by-px-20 heigth-by-px-20 text-dark-filter" alt="dashboard icon" />}
              component={
                <CustomNavLink
                  to={APP_ROUTES.HOME}
                  onClick={() => {
                    setResetFormState(true);
                  }}
                />
              }
            >
              {" "}
              {t("yw10")}
            </MenuItem>
            )
          }
          {
            isShowMenu(RESOURCE_TYPE.PROJECT_INSTANCE) && (
              <MenuItem
                icon={<img src={InstanceIcon} className="width-by-px-20 heigth-by-px-20 text-dark-filter" alt="project instance icon" />}
                component={
                  <CustomNavLink
                    to={APP_ROUTES.PROJECT_INSTANCE}
                    onClick={() => {
                      setResetFormState(true);
                    }}
                  />
                }
              >
                {" "}
                {t("pi10")}
              </MenuItem>
            )
          }
          {
            isShowMenu(RESOURCE_TYPE.PROJECT_INSTANCE) && (
              <MenuItem
                icon={<img src={PackageIcon} className="width-by-px-20 heigth-by-px-20 text-dark-filter" alt="test package icon" />}
                component={
                  <CustomNavLink
                    to={APP_ROUTES.TEST_PACKAGE}
                    onClick={() => {
                      setResetFormState(true);
                    }}
                  />
                }
              >
                {" "}
                {t("tp10")}
              </MenuItem>
            )
          }
          {
            isShowMenu(RESOURCE_TYPE.PROJECT_INSTANCE) && (
              <MenuItem
                icon={<img src={SequenceIcon} className="width-by-px-20 heigth-by-px-20 text-dark-filter" alt="sequence icon" />}
                component={
                  <CustomNavLink
                    to={APP_ROUTES.SEQUENCES}
                    onClick={() => {
                      setResetFormState(true);
                    }}
                  />
                }
              >
                {" "}
                {t("sl10")}
              </MenuItem>
            )
          }
        </Menu>
      </Sidebar>
    </React.Fragment>
  );
};

export default SidebarMenu;
